/** @jsxImportSource theme-ui @jsxRuntime classic */
import {
  CalloutGrid,
  CalloutGridCard,
  Container,
  AnchorSection,
} from '@tishman/components';
import React, { useMemo } from 'react';
import invariant from 'invariant';

import { usePageData } from '../utils';

import type { ComponentPropsWithoutRef } from 'react';

const RinkCalloutGridBlock = (
  props: ComponentPropsWithoutRef<typeof AnchorSection>,
): React.JSX.Element => {
  const { events } = usePageData<Queries.AttractionRinkQuery>();

  const calloutGridTitle = events?.calloutGridTitle;
  const calloutGridCards = events?.calloutGridCards;

  invariant(calloutGridTitle, 'Rink callout grid title is required!');
  invariant(calloutGridCards, 'Rink callout grid cards are required!');

  const rinkCalloutGridProps = useMemo(
    () => ({
      title: calloutGridTitle,
      cards:
        calloutGridCards?.map((card, index) => ({
          index,
          gatsbyImageData: card?.image?.asset?.gatsbyImageData,
          alt: card?.image?.alt ?? '',
          title: card?.title ?? '',
          caption: card?.image?.caption ?? '',
          description: card?.caption ?? '',
          links:
            card?.externalLinks?.map((link) => {
              const isFileType = link && 'asset' in link;

              return {
                url: (isFileType ? link.asset?.url : link?.url) ?? '',
                label: link?.caption ?? '',
              };
            }) ?? [],
        })) ?? [],
    }),
    [calloutGridTitle, calloutGridCards],
  );

  return (
    rinkCalloutGridProps && (
      <AnchorSection
        data-section="RinkCalloutGrid"
        {...props}
        sx={{
          pt: [4, 5],
        }}
      >
        <Container>
          <CalloutGrid hideOffset={true} title={rinkCalloutGridProps.title}>
            {rinkCalloutGridProps.cards.map((card) => (
              <CalloutGridCard key={card.index} {...card} />
            ))}
          </CalloutGrid>
        </Container>
      </AnchorSection>
    )
  );
};

export default RinkCalloutGridBlock;
